import { apiSlice } from "../../app/api/apiSlice"
// import { RemainingWork } from "../../components/models/RemainingWork"

export const remainingWorkApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // getRFID: builder.query<void,void >({
        //     query: (date) => ({
        //         url:`/RFID/GetRFID?date=${date}`,
        //         responseHandler: 'json'
        //     })
        // }),

        getRFID: builder.query<void, { date: string, sortBy: string, direction: string }>({
            query: ({date, sortBy, direction}) => ({
                url:`/RFID/GetRFID?date=${date}&sortBy=${sortBy}&direction=${direction}`,
                responseHandler: 'json'
            })
        }),

        getCubeInformation: builder.query<void, void>({
            query: (rfid) => ({
                url:`/RFID/GetCubeInformation?rfid=${rfid}`,
                responseHandler: 'json'
            })
        }),

        getCubeInformationBySampleNumber: builder.query<void, void>({
            query: (sampleNumber) => ({
                url:`/RFID/GetCubeInformationBySampleNumber?sampleNumber=${sampleNumber}`,
                responseHandler: 'json'
            })
        }),

        getTestResult: builder.query<void, void>({
            query: (code) => ({
                url:`/TestResult/GetTestResult?code=${code}`,
                responseHandler: 'json'
            })
        }),

        getTestResultDate: builder.query<void, void>({
            query: (code) => ({
                url:`/TestResult/GetTestResultDate?code=${code}`,
                responseHandler: 'json'
            })
        }),

        getReviseTestResult: builder.query<string, void>({
            query: (code) => ({
                url:`/TestResult/GetReviseTestResult?code=${code}`,
                responseHandler: (response: { text: () => any }) => response.text()
            })
        }),

        saveReviseTestResult: builder.mutation({
            query: (body) => ({
              url: '/TestResult/SaveReviseTestResult',
              method: 'POST',
              responseHandler: 'text',
               body: { ...body}
            })
        }),

        checkUserPermission: builder.query<void, string>({
            query: (user) => ({
                url:`/Permission/CheckUserPermission?userId=${user}`,
                responseHandler: 'json'
            })
        }),

        // getTestResultByCbtCode: builder.query<void, void>({
        //     query: (cbtCode) => ({
        //         url:`/TestResult/GetTestResultByCbtCode?cbtCode=${cbtCode}`,
        //         responseHandler: 'json'
        //     })
        // }),

        // getTestResultByCbtCodeBySampleNumber: builder.query<void, void>({
        //     query: (sampleNumber) => ({
        //         url:`/TestResult/GetTestResultBySampleNumber?sampleNumber=${sampleNumber}`,
        //         responseHandler: 'json'
        //     })
        // }),
    })
})

export const {
    // useGetUsersQuery,
    // useLazyGetUsersQuery
    // useLazyGetRFIDQuery,
    useLazyGetRFIDQuery,
    useLazyGetCubeInformationQuery,
    useLazyGetCubeInformationBySampleNumberQuery,
    useGetTestResultQuery,
    useLazyGetTestResultQuery,
    useLazyGetTestResultDateQuery,
    useSaveReviseTestResultMutation,
    useLazyCheckUserPermissionQuery,
    useLazyGetReviseTestResultQuery
    // useCheckUserPermissionQuery

    // useLazyGetTestResultByCbtCodeQuery,
    // useLazyGetTestResultByCbtCodeBySampleNumberQuery
} = remainingWorkApiSlice 